import React from 'react';
import { Link } from 'react-router-dom';
import Wordmark from './Wordmark';

const COLUMNS = [
  {
    title: 'Look up',
    links: [
      { name: 'Dictionary', path: '/dictionary' },
      { name: 'Word of the day', path: '/word-of-the-day' },
      { name: 'Translation', path: '/translations' },
      { name: 'Writing tips', path: '/writing-tips' },
    ],
  },
  {
    title: 'Read',
    links: [
      { name: 'Blog', path: '/blog/', external: true },
      { name: 'Tech explained', path: '/blog/tech-explained/', external: true },
    ],
  },
  {
    title: 'About',
    links: [
      { name: 'About us', path: '/about' },
      { name: 'Contact', path: '/contact' },
      { name: 'Privacy policy', path: '/privacy-policy' },
      { name: 'Disclaimer', path: '/disclaimer' },
    ],
  },
];

const linkClass = 'text-ink-soft transition-colors hover:text-ink';

const Footer = () => {
  return (
    <footer className="mt-24 border-t border-rule">
      <div className="wrap grid gap-10 py-12 sm:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1fr]">
        <div>
          <Link to="/" className="rounded-sm text-xl" aria-label="Definitionofthe.com home">
            <Wordmark />
          </Link>
          <p className="mt-3 max-w-xs text-[0.95rem] text-ink-soft">
            Meanings, pronunciations and examples for English words, in plain language.
          </p>
        </div>

        {COLUMNS.map((column) => (
          <div key={column.title}>
            <h2 className="text-[0.95rem] font-semibold text-ink">{column.title}</h2>
            <ul className="mt-3 space-y-2 text-[0.95rem]">
              {column.links.map((link) => (
                <li key={link.name}>
                  {link.external ? (
                    <a href={link.path} className={linkClass}>{link.name}</a>
                  ) : (
                    <Link to={link.path} className={linkClass}>{link.name}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-rule">
        <div className="wrap flex flex-col gap-2 py-6 text-sm text-ink-soft md:flex-row md:justify-between">
          <p>© {new Date().getFullYear()} Definitionofthe.com. All rights reserved.</p>
          <p>
            Definitions from Wiktionary via the Free Dictionary API. Built by{' '}
            <a
              href="https://www.facebook.com/SUMIXDevelopers/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-link"
            >
              SUMIX
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
